import { openBlock as l, createElementBlock as t, createElementVNode as e } from "vue";
const c = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, o = /* @__PURE__ */ e("path", { d: "M13.286 8.41a.75.75 0 0 0-1.342-.671l-2.462 4.926a.75.75 0 0 0 .67 1.085h2.481l-1.92 3.84a.75.75 0 1 0 1.342.671l2.463-4.926a.75.75 0 0 0-.671-1.085h-2.481l1.92-3.84Z" }, null, -1), n = /* @__PURE__ */ e("path", {
  "fill-rule": "evenodd",
  d: "M5.006 22.545h14l-.01-.01c.96 0 1.75-.79 1.75-1.75v-8.26h1.25a.751.751 0 0 0 .53-1.28l-9.29-9.28a1.75 1.75 0 0 0-2.47 0l-9.29 9.28c-.21.22-.28.54-.16.82.11.28.39.46.69.46h1.25v8.27c0 .96.79 1.75 1.75 1.75Zm14.25-1.75c0 .14-.11.25-.25.25-2.644 0-4.148-.002-5.77-.004-1.902-.003-3.968-.006-8.23-.006-.14 0-.25-.11-.25-.25v-9.01c0-.41-.34-.75-.75-.75h-.19l8.02-8c.09-.1.25-.1.35 0l8.01 8h-.19c-.41 0-.75.34-.75.75v9.02Z",
  "clip-rule": "evenodd"
}, null, -1), h = [
  o,
  n
];
function d(r, a) {
  return l(), t("svg", c, [...h]);
}
const i = { render: d };
export {
  i as default,
  d as render
};
